import KnowledgeBaseService from './KnowledgeBaseService';

export default {
	'services.onboardingKnowledgeBaseService': {
		class: KnowledgeBaseService,
		deps: [{ $ref: 'services.APIService' }],
	},
};
